export type WorkOrderStatus =
  | "draft"
  | "new"
  | "inProgress"
  | "notAccepted"
  | "finished"
  | "rejected"
  | "closed"
  | "cancelled"
  | "billed";

export const AllWorkOrderStatuses = [
  "new",
  "inProgress",
  "rejected",
  "draft",
  "notAccepted",
  "finished",
  "closed",
  "cancelled",
  "billed",
];
